var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.data,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "move", attrs: { "auto-width": "", props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "fas fa-arrow-up",
                          disable: !_vm.managerTrainings
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveItem(props, "up")
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "fas fa-arrow-down",
                          disable: !_vm.managerTrainings
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveItem(props, "down")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "hierarchy_order", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.hierarchy_order) +
                          "\n\t\t\t\t"
                      ),
                      _c(
                        "q-popup-edit",
                        {
                          on: {
                            hide: function($event) {
                              return _vm.reorderItems(props.row)
                            }
                          },
                          model: {
                            value: props.row.hierarchy_order,
                            callback: function($$v) {
                              _vm.$set(props.row, "hierarchy_order", $$v)
                            },
                            expression: "props.row.hierarchy_order"
                          }
                        },
                        [
                          _c("q-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.new_order,
                              callback: function($$v) {
                                _vm.new_order = $$v
                              },
                              expression: "new_order"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "type_slug", attrs: { props: props } },
                    [
                      _c("q-icon", {
                        attrs: {
                          name: _vm.getIconName(props.row.type_slug),
                          size: "1.2rem"
                        }
                      }),
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t(props.row.type_slug)) +
                          "\n\t\t\t"
                      )
                    ],
                    1
                  ),
                  _c("q-td", { key: "type_title", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(props.row.type_title) + "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "parent_id", attrs: { props: props } },
                    [
                      _c("q-select", {
                        attrs: {
                          options: _vm.getOptions(props.row),
                          clearable: "",
                          disable: !_vm.managerTrainings
                        },
                        on: {
                          input: function($event) {
                            return _vm.saveConfigure()
                          }
                        },
                        model: {
                          value: props.row.parent_id,
                          callback: function($$v) {
                            _vm.$set(props.row, "parent_id", $$v)
                          },
                          expression: "props.row.parent_id"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "type_avaliable_in", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.fDate(props.row.type_avaliable_in)) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c("q-td", { key: "type_score", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(props.row.type_score) + "\n\t\t\t"
                    )
                  ])
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3 text-right" },
          [
            _c(
              "p",
              { staticClass: "caption" },
              [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t("open_training")) + "\n\t\t\t\t"
                ),
                _c("q-icon", {
                  staticClass: "cursor-pointer",
                  attrs: { name: "far fa-question-circle" },
                  nativeOn: {
                    click: function($event) {
                      _vm.show_training_in_progress_helper = true
                    }
                  }
                })
              ],
              1
            ),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorIsOpen,
                options: _vm.is_open_options,
                disable: _vm.disableIsOpen
              },
              on: {
                input: function($event) {
                  return _vm.changeIsOpen()
                }
              },
              model: {
                value: _vm.is_open,
                callback: function($$v) {
                  _vm.is_open = $$v
                },
                expression: "is_open"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_trainings" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c(
              "q-btn",
              {
                staticClass: "full-width",
                attrs: {
                  color: "negative",
                  label: _vm.$t("unpublish"),
                  icon: "fas fa-ban",
                  disable: !_vm.managerTrainings
                },
                on: {
                  click: function($event) {
                    return _vm.unpublish()
                  }
                }
              },
              [
                !_vm.managerTrainings
                  ? _c("q-tooltip", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("not_allowed")) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c(
              "q-btn",
              {
                staticClass: "full-width",
                attrs: {
                  color: "positive",
                  label: _vm.$t("publish"),
                  icon: "fas fa-upload",
                  disable: !_vm.managerTrainings
                },
                on: {
                  click: function($event) {
                    return _vm.publish()
                  }
                }
              },
              [
                _vm.disableButtons
                  ? _c("q-tooltip", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("no_modules_or_tests_on_training")) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "info",
                label: _vm.$t("duplicate_training"),
                icon: "far fa-copy",
                disable: !_vm.managerTrainings
              },
              on: {
                click: function($event) {
                  _vm.show_confirm_duplicate = true
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.saveChangeIsOpen },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.cancelChangeIsOpen()
                      }
                    }
                  }),
                  _c(
                    "q-btn",
                    {
                      attrs: { color: "primary", disable: _vm.countDown > 0 },
                      on: {
                        click: function($event) {
                          return _vm.saveChangeIsOpen()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("confirm")) +
                          " (" +
                          _vm._s(_vm.countDown) +
                          ") "
                      )
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_alert_change,
            callback: function($$v) {
              _vm.show_alert_change = $$v
            },
            expression: "show_alert_change"
          }
        },
        [
          _c(
            "span",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _vm._v(_vm._s(_vm.$t("close_training")) + "\n\t\t\t"),
              _c("q-icon", {
                staticClass: "cursor-pointer",
                attrs: { name: "far fa-question-circle" },
                nativeOn: {
                  click: function($event) {
                    _vm.show_training_in_progress_helper = true
                  }
                }
              })
            ],
            1
          ),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(_vm.$t("confirm_close_training_this_cannot_be_undone"))
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.duplicateTraining },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_confirm_duplicate = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("confirm") },
                    on: {
                      click: function($event) {
                        return _vm.duplicateTraining()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_confirm_duplicate,
            callback: function($$v) {
              _vm.show_confirm_duplicate = $$v
            },
            expression: "show_confirm_duplicate"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("duplicate_training")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("confirm_duplicate_the_training_and_all_its_contents")
              )
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.handleIsOpen },
          model: {
            value: _vm.show_training_in_progress_helper,
            callback: function($$v) {
              _vm.show_training_in_progress_helper = $$v
            },
            expression: "show_training_in_progress_helper"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("open_training")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("open_training_helper")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }